import { EUrlShortenerSettingsDomainsStates } from '@sigmasms/shared-types'

import { proxy } from '@/utils'

import { serviceNameViaPoint, urlShortenerSettingsDomainsStates } from '@/components/services/url-shortener-settings/domains/utils'

import render from './render'

export default {
  name: 'State',

  mixins: [ proxy() ],

  props: {
    disabled: Boolean,
    required: Boolean
  },

  computed: {
    items() {
      return Object.values(EUrlShortenerSettingsDomainsStates).map(value => {
        return {
          value,
          title: this.getTranslate(`${serviceNameViaPoint}.states.${value}`),
          icon: urlShortenerSettingsDomainsStates[value].icon,
          iconColor: urlShortenerSettingsDomainsStates[value].color
        }
      })
    }
  },

  render
}
